

<script>
export default {
  name: 'AppBar',
  components:{
  }
}
</script>

<style>

</style>
